<template>
  <div>
    <div class="page-wrap" v-if="this.data.rows">
      <h2 class="title-page fw-500">
        <i class="fas fa-book mr-2"></i>ข้อมูลบัญชีฝาก
      </h2>
      <div class="body-content hide-entrie">
        <div class="table-content -color-pri">
          <p>บัญชีฝาก</p>
          <mdb-datatable
            :arrows="true"
            :data="data"
            striped
            bordered
            :searching="false"
            scrollY
            maxHeight="450px"
          />
        </div>
      </div>
      <div class="modal-wrapper">
        <mdb-container>
          <mdb-modal
            :show="showModal"
            @close="showModal = false"
            scrollable
            centered
          >
            <mdb-modal-header>
              <mdb-modal-title>
                <mdb-icon icon="fingerprint" />
                จัดการข้อมูลบัญชีฝาก</mdb-modal-title
              >
            </mdb-modal-header>
            <mdb-modal-body>
              <div class="row">
                <div class="col-12 text-center my-4" v-if="showModaldata">
                  <div class="row mt-2">
                    <div class="col-4 align-self-center">ธนาคาร</div>
                    <div class="col-8 pl-0">
                      <input
                        type="text"
                        id="pro_price"
                        disabled
                        :value="showModaldata.bank_code"
                        class="form-control form-control-sm"
                        width="100%"
                      />
                    </div>
                  </div>
                  <div class="row justify-content-center mt-2">
                    <div class="col-4 align-self-center">เลขบัญชี</div>
                    <div class="col-8 pl-0">
                      <input
                        type="text"
                        id="pro_price"
                        disabled
                        :value="showModaldata.bank_number"
                        class="form-control form-control-sm"
                        width="100%"
                      />
                    </div>
                  </div>
                  <div class="row justify-content-center mt-2">
                    <div class="col-4 align-self-center">ชื่อบัญชี</div>
                    <div class="col-8 pl-0">
                      <input
                        type="text"
                        id="pro_price"
                        disabled
                        :value="showModaldata.bank_name"
                        class="form-control form-control-sm"
                        width="100%"
                      />
                    </div>
                  </div>
                  <div class="row justify-content-center mt-2 mb-3">
                    <div class="col-4 align-self-center">สถานะบัญชี</div>
                    <div class="col-8 pl-0 d-flex align-items-center">
                      <label class="switch" style="">
                        <input type="checkbox" true-value="OPEN"
                      false-value="CLOSE" v-model="status"/>
                        <span class="slider round"></span>
                      </label>
                      <div class="col-5 align-self-center pl-0">ปิด - เปิด</div>
                    </div>
                  </div>
                    <div class="row justify-content-center mt-2 mb-3">
                    <div class="col-4 align-self-center">ลบบัญชี</div>
                    <div class="col-8 pl-0 d-flex align-items-center">
                        <div class="bttn-delete-acc" @click="popupDelete()">
                          <i class="far fa-trash-alt mr-2"></i>ลบบัญชีนี้
                        </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-search color_white font12"
                    style="font-weight:400;"
                    @click="editDataDeposit()"
                  >
                    บันทึก
                  </button>
                  <button
                    type="button"
                    class="btn btn-cancel color_white font12"
                    style="font-weight:400;"
                    @click="editDataDepositcancle()"
                  >
                    ยกเลิก
                  </button>
                </div>
              </div>
            </mdb-modal-body>
          </mdb-modal>
        </mdb-container>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
var axios = require("axios");
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";
export default {
  components: {},
  data() {
    return {
      showModal: false,
      showModaldata: null,
      dataremain: null,
      status:null,
      data: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
          },
          {
            label: "ธนาคาร",
            field: "bank_code",
            sort: true,
          },
          {
            label: "เลขที่บัญชี",
            field: "bank_number",
            sort: true,
          },
          {
            label: "ชื่อบัญชี",
            field: "bank_name",
            sort: true,
          },
          {
            label: "สถานะบัญชี",
            field: "status",
            sort: true,
            format: (value) => {
              return `<div class="text-center btnbtn" style="max-width:110px;" data-status="${
                value === 1 ? "true" : "false"
              }">
                <label class=" text-white font14"  style="cursor: pointer;background-color:${
                  value === 1 ? "#00D717" : "#FE1C1C"
                };border-radius:6px;">
                    <p class="mb-0" style="font-size:0.6rem;padding:2px 6px;">${
                      value === 1 ? "เปิดใช้งาน" : "ปิดใช้งาน"
                    }</p>
                </label>
                </div>`;
            },
          },
          {
            label: "จัดการบัญชี",
            field: "id",
            sort: true,
            format: (value) => {
              if (value) {
                return (
                  '<div class="text-center btnbtn classclick" style="max-width:110px;" dataid="' +
                  value +
                  '"><label class="bg-file-search text-white font14" style="cursor: pointer;" ><mdb-icon far icon="file-alt" /><i class="fas fa-file-alt fa-13"></i></label></div>'
                );
              }
            },
          },
        ],
        rows: null,
      },
    };
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      loadsession: "loadsession",
      callApiMotherFucker: "callApiMotherFucker",
    }),
     async editDataDeposit(){
        const payload = {
          id: this.showModaldata.id,
          action: this.status,
        };
        const token = jwt.sign(payload, this.$keypayload);
        var config = {
          method: "POST",
          url: "https://sms-fast.warmlight.online/api/updateBankDeposit",
          headers: {
            Authorization: "Bearer " + this.tokens,
          },
          data: {
            token: token,
          },
        };
        let contextval2 = this;
        await axios(config)
          .then(function(response) {
            if (response.data) {
            contextval2.showModal = false;
            contextval2.NotifyXXNew(response.data.msg, response.data.code);
            contextval2.LoadDatatable();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      
    },
    popupDelete(){
  this.$swal.fire({
      icon: 'error',
  title: 'คุณต้องการลบบัญชีนี้หรือไม่',
  showCancelButton: true,
  cancelButtonColor: '#464646',
  confirmButtonText: 'ลบบัญชี',
  confirmButtonColor: '#e0001e',
}).then((result) => {
  if (result.isConfirmed) {
    this.deleteDataDeposit();
  } else if (result.isDenied) {
    this.$swal.fire('Changes are not saved', '', 'info')
  }
})

    },
    async deleteDataDeposit(){
       const payload = {
          id: this.showModaldata.id,
        };
        const token = jwt.sign(payload, this.$keypayload);
        var config = {
          method: "POST",
          url: "https://sms-fast.warmlight.online/api/deleteBankDeposit",
          headers: {
            Authorization: "Bearer " + this.tokens,
          },
          data: {
            token: token,
          },
        };
        let contextval2 = this;
        await axios(config)
          .then(function(response) {
            if (response.data) {
            contextval2.showModal = false;
            contextval2.NotifyXXNew(response.data.msg, response.data.code);
            contextval2.LoadDatatable();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    editDataDepositcancle() {
      this.showModal = false;
    },
    onClickList() {
      let edit_detial = this;
      $(".classclick").on("click", function() {
        let id = $(this).attr("dataid") || 0;
        edit_detial.idedituser = id; // เอาid มาเก็บไว้ในตัวแปร idedituser เพื่อจะนำไปอัพเดท
        
        if (id > 0) {
          edit_detial.showModal = true;
          edit_detial.showModaldata = null;
          edit_detial.dataremain.forEach((element) => {
            if (element.id === parseInt(id)) {
              edit_detial.showModaldata = element;
            }
          });
        }
      });
    },  
  NotifyXXNew(message, code) {
      let icon = "warning";
      if (code == 0) {
        icon = "success";
      }
      this.$swal({
        text: message,
        icon: icon,
        timer: 5000,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
    async LoadDatatable(){
      this.data.rows = null;
    var config = {
      method: "get",
      url: "https://sms-fast.warmlight.online/api/getBankList",
      headers: {
        Authorization: "Bearer " + this.tokens,
      },
    };
    await axios(config)
      .then((response) => {
        this.dataremain = response.data.payload;
        this.data.rows = this.$add_index(response.data.payload);
      })
      .catch((error) => {
        console.log(error);
      });
    this.onClickList();
    }
  },
    
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      tokens: "tokens",
    }),
  },
  mounted() {
   this.LoadDatatable();
  },
};
</script>

<style>
.bttn-delete-acc{
  background:rgb(252, 50, 50);
  color:#fff;
  cursor: pointer;
  padding: 2px 15px;
  border-radius: 5px;
  font-size: 0.9rem;
      box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
}
.swal2-title{
  font-size: 1.2rem !important; 
    font-weight: 400 !important;
}
.swal2-styled {
    font-weight: 400 !important;
}

</style>
